import { VFC } from 'react'
import { CLOSE_ICON } from 'src/assets/images'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { Event } from 'src/models/Event'
import { LoginUser } from 'src/models/User'
import { truewhite } from 'src/styles/colors'
import styled from 'styled-components'
import { EventFormBase } from './EventFormBase'

const EventForm: VFC<
  ModalProps<{
    user: LoginUser
    event: Event
  }>
> = ({ close, user, event }) => {
  return (
    <EventModalFormLayout>
      <FormWrap>
        {user.loggedIn && (
          <EventFormBase user={user} event={event} modalClose={close} />
        )}
      </FormWrap>
      <CloseButton type="button" onClick={close}>
        <img src={CLOSE_ICON} alt="閉じる" />
      </CloseButton>
    </EventModalFormLayout>
  )
}

const EventModalFormLayout = styled.div`
  padding: 0 20px;
  position: relative;
`

const FormWrap = styled.div`
  padding: 50px;
  width: 100%;
  background-color: ${truewhite};
  border-radius: 10px;
  overflow: scroll;
  height: 80vh;
`
const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 30px;
  img {
    width: 35px;
    height: 35px;
  }
`

export const EventFormModal = asModal(EventForm, {
  inescapable: true,
  scrollable: true,
})
